































































































































import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import { colorClassByDelivered } from "@/utils/page-utils";
import CdpGroupFilter from "@/components/CDP/Statistic/CdpGroupFilter.vue";
import { CdpGroupItem } from "@/store/cdp/statistic/types";
import GroupCharts from "@/components/Statistics/GroupCharts.vue";

@Component({
  components: {CdpGroupFilter, ScrollButton, GroupCharts},
  methods: {colorClassByDelivered},
})
export default class CdpGroup extends BaseItemsPage<CdpGroupItem> {

  @Getter("cdpStatisticGroup") responseItems!: CdpGroupItem[];

  is_show_filter = true;
  is_show_graphics = true;

  currentSort = "date";
  currentSortOrder = "asc";

  tableFields = this.tableFieldsDefault;

  group_by = '';
  optionally_group_by = '';

  onGroupByChange(data: any) {
    this.group_by = data.groupBy
    this.optionally_group_by = data.optionallyGroupBy
  }

  print(item: string, totalRow: boolean) {
    if (totalRow) return this.group_by ? '' : this.$t('inAll');
    return item ?? this.$t('unnamed')
  }

  getData(): CdpGroupItem[] {
    return this.responseItems;
  }

  get tableFieldsDefault() {
    return ["new", "processed", "error", "total"];
  }

  get totalData(): CdpGroupItem {
    let total = {
      totalRow: "This is the last row of the table",
      new: 0,
      processed: 0,
      error: 0,
      total: 0
    };
    this.tableData.forEach( (row: CdpGroupItem) => {
      total.new += row.new;
      total.processed += row.processed;
      total.error += row.error;
      total.total += row.total;
    });
    return total;
  }

  get compareData(): CdpGroupItem[] {
    return [...this.queriedData, this.totalData];
  }
}
